// Main js file for the object
function cart() {
  console.log('cart');
}

export default cart;
